var _excluded = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Clean Common Props
 *
 * Borrowed from the original `react-select` package
 *
 * @see {@link https://github.com/JedWatson/react-select/blob/edf5265ee0158c026c9e8527a6d0490a5ac2ef23/packages/react-select/src/utils.ts#L75-L110}
 */
export var cleanCommonProps = function cleanCommonProps(props) {
  // className
  var className = props.className,
      clearValue = props.clearValue,
      cx = props.cx,
      getStyles = props.getStyles,
      getClassNames = props.getClassNames,
      getValue = props.getValue,
      hasValue = props.hasValue,
      isMulti = props.isMulti,
      isRtl = props.isRtl,
      options = props.options,
      selectOption = props.selectOption,
      selectProps = props.selectProps,
      setValue = props.setValue,
      theme = props.theme,
      innerProps = _objectWithoutPropertiesLoose(props, _excluded);

  return _extends({}, innerProps);
};
//# sourceMappingURL=utils.js.map